<div class="container py-4">
  <div class="card">
    <div class="rep-card-header">
      <i class="bi bi-geo-alt me-2"></i>
      {{ (isNew ? 'admin.locations.title_new' : 'admin.locations.title_edit') | translate }}
    </div>
    <div class="card-body">
      <form *ngIf="location" ngNativeValidate (ngSubmit)="save()">
        <fieldset [disabled]="disabled" class="border-0 p-0 m-0">
        <!-- Základní údaje -->
        <h5 class="section-title"><i class="bi bi-info-circle me-2"></i>{{ 'admin.locations.basic_info' | translate }}</h5>

        <div class="row mb-3">
          <div class="col-md-12">
            <label class="form-label">{{ 'admin.locations.name' | translate }} *</label>
            <s-input type="text" name="name" [(model)]="location.name" [required]="true"></s-input>
          </div>
        </div>

        <!-- Adresa -->
        <h5 class="section-title mt-4"><i class="bi bi-map me-2"></i>{{ 'admin.locations.address' | translate }}</h5>

        <div class="row mb-3">
          <div class="col-md-5">
            <label class="form-label">{{ 'admin.locations.street' | translate }}</label>
            <s-input type="text" name="street" [(model)]="location.street"></s-input>
          </div>
          <div class="col-md-4">
            <label class="form-label">{{ 'admin.locations.city' | translate }}</label>
            <s-input type="text" name="city" [(model)]="location.city"></s-input>
          </div>
          <div class="col-md-3">
            <label class="form-label">{{ 'admin.locations.zip' | translate }}</label>
            <s-input type="text" name="zip" [(model)]="location.zip"></s-input>
          </div>
        </div>

        <!-- <div class="row mb-3">
          <div class="col-md-4">
            <label class="form-label">{{ 'status.status' | translate }}</label>
            <s-input type="switch" name="is_active" [(model)]="location.is_active"></s-input>
          </div>
        </div> -->

        <!-- REP Nastavení -->
        <h5 class="section-title mt-4"><i class="bi bi-ev-station me-2"></i>{{ 'admin.locations.settings' | translate }}</h5>

        <div class="row mb-3">
          <div class="col-md-3 d-flex align-items-end">
            <div>
              <label class="form-label d-block">{{ 'admin.locations.rep_enabled' | translate }}</label>
              <s-input type="switch" name="is_rep_enabled" [(model)]="locationSettings.is_rep_enabled"></s-input>
            </div>
          </div>
          <div class="col-md-3 d-flex align-items-end">
            <div>
              <label class="form-label d-block">{{ 'admin.locations.open_24_7' | translate }}</label>
              <s-input type="switch" name="is_open_24_7" [(model)]="locationSettings.is_open_24_7"
                (onChange)="toggleOpen24x7()"></s-input>
            </div>
          </div>
          <div class="col-md-3" *ngIf="!locationSettings.is_open_24_7">
            <label class="form-label">{{ 'admin.locations.opening_time' | translate }}</label>
            <s-input type="time" name="opening_time" [(model)]="locationSettings.opening_time"></s-input>
          </div>
          <div class="col-md-3" *ngIf="!locationSettings.is_open_24_7">
            <label class="form-label">{{ 'admin.locations.closing_time' | translate }}</label>
            <s-input type="time" name="closing_time" [(model)]="locationSettings.closing_time"></s-input>
          </div>
        </div>

        <!-- API klíč - pouze pro existující lokace (přesunuto nad stanice) -->
        <div class="row mb-3" *ngIf="!isNew">
          <div class="col-md-8">
            <label for="location-api-key" class="form-label">{{ 'admin.locations.api_key' | translate }}</label>
            <div class="input-group">
              <input #apiKeyInput type="text" id="location-api-key" class="form-control"
                [value]="locationSettings.api_key || ''" readonly>
              <button type="button" class="btn btn-outline-secondary"
                [title]="'admin.locations.api_key_copy' | translate"
                (click)="apiKeyInput.select(); copyApiKey()">
                <i class="bi bi-clipboard"></i>
              </button>
              <button type="button" class="btn btn-outline-warning"
                [title]="'admin.locations.api_key_regenerate' | translate"
                [disabled]="disabled" (click)="regenerateApiKey()">
                <i class="bi bi-arrow-repeat"></i>
              </button>
            </div>
            <small class="text-muted">{{ 'admin.locations.api_key_hint' | translate }}</small>
          </div>
        </div>

        <!-- Stanice (embedded, max 5, min 1) -->
        <h5 class="section-title mt-4">
          <i class="bi bi-ev-station me-2"></i>{{ 'admin.locations.stations' | translate }}
          <small class="text-muted ms-2">({{ stations.length }} / {{ STATION_LIMIT }})</small>
        </h5>

        <div class="row mb-2" *ngFor="let st of stations; let i = index; trackBy: trackByIndex">
          <div class="col-md-3">
            <label class="form-label" *ngIf="i === 0">{{ 'admin.stations.name' | translate }} *</label>
            <s-input type="text" [name]="'station_name_' + i" [(model)]="st.name" [required]="true"
              [placeholder]="'admin.stations.name_placeholder' | translate"></s-input>
          </div>
          <div class="col-md-2">
            <label class="form-label" *ngIf="i === 0">{{ 'admin.stations.capacity' | translate }} *</label>
            <s-input type="int" [name]="'station_capacity_' + i" [(model)]="st.capacity_kwh" [required]="true"></s-input>
          </div>
          <div class="col-md-2">
            <label class="form-label" *ngIf="i === 0">{{ 'admin.stations.latitude' | translate }}</label>
            <s-input type="decimal" [name]="'station_lat_' + i" [(model)]="st.latitude" step="any"
              [placeholder]="'admin.stations.latitude_placeholder' | translate"></s-input>
          </div>
          <div class="col-md-2">
            <label class="form-label" *ngIf="i === 0">{{ 'admin.stations.longitude' | translate }}</label>
            <s-input type="decimal" [name]="'station_lng_' + i" [(model)]="st.longitude" step="any"
              [placeholder]="'admin.stations.longitude_placeholder' | translate"></s-input>
          </div>
          <div class="col-md-1">
            <label class="form-label d-block" *ngIf="i === 0">{{ 'active' | translate }}</label>
            <s-input type="switch" [name]="'station_active_' + i" [(model)]="st.is_active"></s-input>
          </div>
          <div class="col-md-2 d-flex align-items-end justify-content-end">
            <button type="button" class="btn btn-outline-danger"
              [disabled]="disabled || stations.length <= 1"
              (click)="removeStation(i)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <button type="button" class="btn btn-outline-success btn-sm"
              [disabled]="disabled || stations.length >= STATION_LIMIT"
              (click)="addStation()">
              <i class="bi bi-plus me-1"></i>{{ 'admin.locations.add_station' | translate }}
            </button>
          </div>
        </div>

        </fieldset>
        <!-- Akce -->
        <div class="form-actions">
          <div>
            <button type="button" class="btn btn-outline-primary" (click)="goBack()">
              <i class="bi bi-arrow-left me-2"></i>{{ 'back' | translate }}
            </button>
            <button type="button" class="btn btn-outline-danger ms-2" *ngIf="!isNew"
              [disabled]="disabled" (click)="delete()">
              <i class="bi bi-trash me-2"></i>{{ 'delete' | translate }}
            </button>
          </div>
          <button type="submit" class="btn btn-accent" [disabled]="disabled">
            <i class="bi bi-save me-2"></i>{{ 'save' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
